import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { dataHas } from '../../common/ambient'
import {
  FormattedDataPoint
} from './'

export default class HeatIndexWidget extends PureComponent {
  static propTypes = {
    currentDevice: PropTypes.object
  };

  render() {
    const { currentDevice } = this.props
    const { lastData } = currentDevice
    const data = lastData
    let widget = <div className="heatindex-widget hidden" />
    const currentDataHas = dataHas(data)
    if(currentDataHas(['heatindexf'])) {
      widget =
      <div className="big-number heatindex-widget heatindexf">
        <FormattedDataPoint type={'heatindexf'} row={data} />
      </div>
    } else if(currentDataHas(['feelsLike', 'tempf'])) {
      widget =
      <div className="big-number heatindex-widget">
        <FormattedDataPoint type={'heatindexf'} value={data.tempf > 68 ? data.feelsLike : data.tempf} />
      </div>
    }
    return widget
  }
};
HeatIndexWidget.displayName = 'HeatIndexWidget'
